import React, { useState } from 'react';

import { useSnackbar } from 'notistack';

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
} from '@mui/material';

import Spinner from '~/components/Common/Spinner';

import { useCreateAmenity } from '~/hooks/apis/amenities/useCreateAmenity';

interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  refreshAmenities: () => void;
}

export default function NewAmenityModal({ isModalOpen, closeModal, refreshAmenities }: Props) {
  const [name, setName] = useState('');
  const [builtIn, setBuiltIn] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const createAmenityMutation = useCreateAmenity();

  const handleSubmit = async () => {
    if (!name) {
      enqueueSnackbar('Please fill in all fields', { variant: 'error' });
      return;
    }

    try {
      await createAmenityMutation.mutateAsync({ name, builtIn });
      enqueueSnackbar('Amenity created successfully', { variant: 'success' });
      refreshAmenities();
      closeModal();
      setName('');
      setBuiltIn(false);
    } catch (error) {
      enqueueSnackbar((error as Error).message, { variant: 'error' });
    }
  };

  return (
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>Create New Amenity</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          type="text"
          fullWidth
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Name"
        />
        <FormControlLabel
          control={<Checkbox checked={builtIn} onChange={(e) => setBuiltIn(e.target.checked)} />}
          label="Built In"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={closeModal} disabled={createAmenityMutation.isPending}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={createAmenityMutation.isPending}>
          {createAmenityMutation.isPending ? <Spinner size={15} inline /> : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
